import state from '@/store/modules/editor/state'
import mutations from '@/store/modules/editor/mutations'
import actions from '@/store/modules/editor/actions'
import getters from '@/store/modules/editor/getters'

const editor = {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
  modules: {},
}

export default editor
